module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "header-bar text-center mcBG"
  }, [_c('img', {
    attrs: {
      "src": "static/img/i3v_icon_white.png"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("uManage Mobile" + _vm._s(_vm.sandboxTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "form-container"
  }, [_c('h2', {
    staticClass: "scText"
  }, [_vm._v("Login")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.loginError) ? _c('div', [_c('div', {
    staticClass: "error-message"
  }, [_vm._v("\n              There was an issue logging in. Please check your Username and Password and try again.\n            ")])]) : _vm._e()]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user),
      expression: "user"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "username",
      "type": "text",
      "placeholder": "Username",
      "required": ""
    },
    domProps: {
      "value": (_vm.user)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pass),
      expression: "pass"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.pass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pass = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary mcBG scBGHover",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n              Login "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginLoading),
      expression: "loginLoading"
    }]
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])], 1), _vm._v(" "), _c('pre', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v("      " + _vm._s(_vm.$data) + "\n    ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f565fa2c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 863
// module chunks = 2